export function getBlankRecord() {
  return {
    type: null,
    template: null
  };
}
